import { useCallback, useMemo } from "react";
import { usePersistentState } from "./use-persistent-state";

/**
 * Закрепление расхождений в master-pane (фича 024 ③).
 *
 * Persist по `runId` (по решению пользователя Q4) — при следующем прогоне
 * pinned-список начинается заново.
 */
export interface UsePinnedDiscrepanciesResult {
	pinnedIds: ReadonlySet<string>;
	togglePinned: (id: string) => void;
	isPinned: (id: string) => boolean;
}

export function usePinnedDiscrepancies(runId: string | undefined): UsePinnedDiscrepanciesResult {
	// Пустой ключ когда runId ещё не пришёл — usePersistentState работает как
	// обычный useState без записи в localStorage, без засорения «default» ключа.
	const key = runId ? `recon:pinned:${runId}` : "";
	const [list, setList] = usePersistentState<string[]>(key, []);

	const set = useMemo(() => new Set(list), [list]);

	const togglePinned = useCallback(
		(id: string) => {
			setList((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
		},
		[setList],
	);

	const isPinned = useCallback((id: string) => set.has(id), [set]);

	return { pinnedIds: set, togglePinned, isPinned };
}
